import { useMutation, useQueryCache } from "react-query";
import useInspection from "./useInspection";
import { useSelector } from "react-redux";
import network from "../../../../selectors/network";
import { useToasts } from "react-toast-notifications";
import putInspectionRequestRejected from "../../api/inspections/putInspectionRequestRejected";

interface IUseInspectionRejectRequestMutation {
  id: number | string;
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}
export default function useInspectionRejectRequestMutation({
  id,
  onSuccess = () => {},
  onError = () => {},
}: IUseInspectionRejectRequestMutation) {
  const queryCache = useQueryCache();
  const networkHeaders = useSelector(network.defaultHeaders);
  const { addToast } = useToasts();

  const { queryKey } = useInspection({ id });

  const [inspectionRejectRequestMutation] = useMutation(putInspectionRequestRejected(networkHeaders, Number(id)), {
    onSuccess: () => {
      onSuccess();

      addToast("Inspection request rejected successfully!", { appearance: "success", autoDismiss: true });
      queryCache.invalidateQueries(queryKey);
    },
    onError: (error: unknown) => {
      onError(error);

      addToast("Inspection requested rejection failed!", { appearance: "error", autoDismiss: true });
    },
  });

  return { inspectionRejectRequestMutation };
}
